import React from 'react';
import Helper from '../functions/Helper.js'

class RatingCircle extends React.Component{
  render(){
    let strokeDasharray = (Math.PI * 0.88 * this.props.rating * 10) + "%";
    let rotateDegree=-90+(((10-this.props.rating)/10)*360);
    return(
      <div style={{position:"relative",textAlign:"center",...this.props.containerStyle}}>
        <svg viewBox='0 0 100 100'>
          <circle cx='50%' cy='50%' r='44%' fill='#fff'/>
          <circle cx='50%' cy='50%' r='44%' fill='transparent' stroke='hsl(0, 0%, 94%)' strokeWidth='7%'/>
          {this.props.rating!=="NA" &&
            <circle transform={'rotate('+rotateDegree+', 50, 50)'} cx='50%' cy='50%' r='44' fill='transparent'
              stroke={Helper.get_color(this.props.rating,"bg")} strokeWidth='7%'
              strokeDasharray={strokeDasharray} />
          }
        </svg>
        <div style={{position: 'absolute',top:0,bottom:0,left:0,right:0,alignItems:"center",justifyContent:"center",display:"flex"}}>
          <div  style={{fontSize: 70,lineHeight:"70px",letterSpacing:-2,color:"hsl(0, 0%, 50%)",fontFamily:'Lato, sans-serif',...this.props.textStyle}}>
            <span>
              {Helper.printRating(this.props.rating)}
            </span>
          </div>
        </div>
      </div>
    );
  }
}



export default RatingCircle;
